import Breadcrumbs from './breadcrumbs/breadcrumbs.vue'
import EError from './error/error.vue'
import Form from './form/form.vue'
import FormGroup from './form/form-group.vue'
import Input from './input/input.vue'
import Url from './input/url.vue'
import Calendar from './input/calendar.vue'
import CalendarRange from './input/calendar-range.vue'
import Location from './location/location.vue'
import FormModal from './modal/form-modal.vue'
import Modal from './modal/modal.vue'
import Pagination from './pagination/pagination.vue'
import Select from './select/select.vue'
import Year from './select/year.vue'
import SelectYear from './select/year-selector'
import Month from './select/month.vue'
import Suggestion from './suggestion/suggestion.vue'
import SuggestionMultiselect from './suggestion/suggestion-multiselect.vue'
import Table from './table/table.vue'
import TableCheckedList from './table-checked-list/table-checked-list.vue'
import TableEditable from './table-editable/table-editable.vue'
import TableInner from './table-inner/table-inner.vue'
import Textarea from './textarea/textarea.vue'
import Toolbar from './toolbar/toolbar.vue'
import PerfectScrollbar from './perfect-scrollbar/perfect-scrollbar.vue'
import CheckboxMulti from './input/checkbox-multi.vue'
import Checkbox from './input/checkbox.vue'
import Radio from './input/radio.vue'
import Chart from './chart/chart.vue'
import RoleEditor from './role-editor/role-editor.vue'
import Button from './button/button.vue'
import ButtonAdd from './button/button-add.vue'
import ButtonEdit from './button/button-edit.vue'
import ButtonDelete from './button/button-delete.vue'
import FileUploader from './file-uploader/file-uploader.vue'
import UserFiles from './user-files/user-files.vue'
import Progress from './progress/progress'
import SelectList from './select/select-list'
import Time from './input/time'
import DataGridInner from './data-grid/data-grid-inner'
import ImageViewer from './image-viewer/image-viewer'
import SimpleFileUploader from './input/simple-file-uploader'
import Steps from './steps/steps'
import Slider from './slider/slider'
import JournalJsonLog from './journal/journal-json-log'
import SelectNestedList from './select/select-nested-list'
import Address from './address/address'
import FormTabs from './form/form-tabs'
import FormSubtitle from './form/form-subtitle'
import FormSearchFilter from './form/form-search-filter'
import FormSearchFilterButtons from './form/form-search-filter-buttons'
import Tags from './tags/tags'
import TagsInput from './tags/tags-input'
// src/app/geo/components uses local import

export default function (Vue, opts = {}) {
  Vue.component(Breadcrumbs.name, Breadcrumbs)

  Vue.component(EError.name, EError)

  Vue.component(Form.name, Form)
  Vue.component(FormGroup.name, FormGroup)
  Vue.component(Input.name, Input)
  Vue.component(Url.name, Url)
  Vue.component(Textarea.name, Textarea)

  Vue.component(Calendar.name, Calendar)
  Vue.component(Time.name, Time)
  Vue.component(CalendarRange.name, CalendarRange)

  Vue.component(Location.name, Location)
  Vue.component(Select.name, Select)
  Vue.component(Year.name, Year)
  Vue.component(SelectYear.name, SelectYear)
  Vue.component(Month.name, Month)
  Vue.component(SelectList.name, SelectList)
  Vue.component(SelectNestedList.name, SelectNestedList)
  Vue.component(Suggestion.name, Suggestion)
  Vue.component(SuggestionMultiselect.name, SuggestionMultiselect)
  Vue.component(CheckboxMulti.name, CheckboxMulti)
  Vue.component(Checkbox.name, Checkbox)
  Vue.component(Radio.name, Radio)
  Vue.component(Chart.name, Chart)

  Vue.component(Modal.name, Modal)
  Vue.component(FormModal.name, FormModal)

  Vue.component(Pagination.name, Pagination)
  Vue.component(Toolbar.name, Toolbar)

  Vue.component(Table.name, Table)
  Vue.component(TableCheckedList.name, TableCheckedList)
  Vue.component(TableEditable.name, TableEditable)
  Vue.component(TableInner.name, TableInner)

  Vue.component(PerfectScrollbar.name, PerfectScrollbar)
  Vue.component(RoleEditor.name, RoleEditor)

  Vue.component(ButtonAdd.name, ButtonAdd)
  Vue.component(ButtonEdit.name, ButtonEdit)
  Vue.component(ButtonDelete.name, ButtonDelete)
  Vue.component(Button.name, Button)

  Vue.component(FileUploader.name, FileUploader)
  Vue.component(UserFiles.name, UserFiles)

  Vue.component(Progress.name, Progress)
  Vue.component(DataGridInner.name, DataGridInner)

  Vue.component(ImageViewer.name, ImageViewer)

  Vue.component(SimpleFileUploader.name, SimpleFileUploader)

  Vue.component(Steps.name, Steps)
  Vue.component(Slider.name, Slider)

  Vue.component(JournalJsonLog.name, JournalJsonLog)

  Vue.component(Address.name, Address)

  Vue.component(FormTabs.name, FormTabs)
  Vue.component(FormSubtitle.name, FormSubtitle)

  Vue.component(FormSearchFilter.name, FormSearchFilter)
  Vue.component(FormSearchFilterButtons.name, FormSearchFilterButtons)

  Vue.component(Tags.name, Tags)
  Vue.component(TagsInput.name, TagsInput)
}
